import { useCallback } from 'react';
import { useFastStore } from '../context/FastContext';
export const useTriggerOverlay = () => {
  const openOverlay = useFastStore(state => state.handlers.onOpenOverlay);
  return useCallback(overlay => {
    openOverlay.forEach(cb => cb({
      overlay
    }));
  }, [openOverlay]);
};